<template>
  <div class="ALL">
    <el-menu :collapse="isCollapse" :collapse-transition="false" router text-color="rgba(255, 255, 255, 0.8)"
      :width="isCollapse ? '46px' : '262px'" active-text-color="#ffffff" :default-active="activeMenu"
      @select="handleSelect" class="custom-menu">
      <!-- 没有子菜单 -->
      <!-- <el-menu-item index="/overview">
        <div style="position: relative; display: flex; align-items: center;">
          <img :src="activeMenu === '/overview' ? require('@/assets/base/km.png') : require('@/assets/base/km_light.png')"
            alt="left-icon" width="20" height="20" style="position: absolute; left: -22px;z-index: 10;">
          <img :src="activeMenu === '/overview' ? require('@/assets/base/km_light.png') : require('@/assets/base/km.png')"
            alt="icon" width="20" height="20" style="margin: 0 12px;">
          <span slot="title">领域知识库管理</span>
        </div>
      </el-menu-item> -->

      <!-- 一级菜单 -->
      <el-submenu :class="{ 'is-active': isCollapse && activeMenu === item.path }" :index="item.path || item.authorName"
        v-for="item in menulist" :key="item.id" style="position: relative">
        <template slot="title">
          <router-link v-if="item.path != null" :to="item.path" style="text-decoration: none; position: relative">
            <img :src="activeMenu == item.path
                ? require('@/assets/base/kgm_light.png')
                : require('@/assets/base/kgm.png')
              " alt="icon" width="20" height="20" style="margin: 0 12px" />
            <span>{{ item.authorName }}</span>
          </router-link>
          <div v-else style="position: relative">
            <!-- 左侧图标 -->

            <img :src="activeMenu === '/manage/ontology' ||
                activeMenu === '/manage/instance' ||
                activeMenu === '/mergeGraph/extractManage' ||
                activeMenu === '/mergeGraph/extract' ||
                activeMenu === '/mergeGraph/merge' ||
                activeMenu === '/manage/depth'
                ? require('@/assets/base/kgm_light.png')
                : require('@/assets/base/kgm.png')
              " alt="icon" width="20" height="20" style="margin: 0 12px" />
            <span>{{ item.authorName }}</span>
          </div>
        </template>

        <!-- 二级菜单 -->
        <el-menu-item-group v-for="subItem in item.children" :key="subItem.id">
          <template v-if="subItem.children && subItem.children.length > 0">
            <!-- 包含子菜单的二级菜单使用 el-submenu 来创建三级菜单 -->
            <el-submenu :index="subItem.path">
              <template slot="title">
                <span>{{ subItem.authorName }}</span>
              </template>
              <!-- 三级菜单 -->
              <el-menu-item :index="subSubItem.path" v-for="subSubItem in subItem.children" :key="subSubItem.id">
                <span slot="title">{{ subSubItem.authorName }}</span>
              </el-menu-item>
            </el-submenu>
          </template>
          <template v-else>
            <!-- 没有子菜单的二级菜单直接作为 el-menu-item -->
            <el-menu-item :index="subItem.path" :key="subItem.id">
              <span slot="title">{{ subItem.authorName }}</span>
            </el-menu-item>
          </template>
        </el-menu-item-group>
      </el-submenu>
      <el-menu-item index="/mergeGraph/merge">
        <div style="position: relative; display: flex; align-items: center">

          <img :src="activeMenu === '/mergeGraph/merge'
              ? require('@/assets/base/fm_light.png')
              : require('@/assets/base/fm.png')
            " alt="icon" width="20" height="20" style="margin: 0 12px" />
          <span slot="title">知识融合</span>
        </div>
      </el-menu-item>
      <el-menu-item index="/manage/depth">
        <div style="position: relative; display: flex; align-items: center">

          <img :src="activeMenu === '/manage/depth'
              ? require('@/assets/base/fm_light.png')
              : require('@/assets/base/fm.png')
            " alt="icon" width="20" height="20" style="margin: 0 12px" />
          <span slot="title">知识推理</span>
        </div>
      </el-menu-item>
      <el-menu-item index="/kgBase/index">
        <div style="position: relative; display: flex; align-items: center">

          <img :src="activeMenu === '/kgBase/index'
              ? require('@/assets/base/fm_light.png')
              : require('@/assets/base/fm.png')
            " alt="icon" width="20" height="20" style="margin: 0 12px" />
          <span slot="title">文件管理</span>
        </div>
      </el-menu-item>
    </el-menu>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      // 默认选中
      activeMenu: "/manage/ontology",
      // 菜单数据
      menulist: [
        {
          authorName: "知识构建",
          path: null,
          children: [
            { authorName: "知识本体建模", path: "/manage/ontology", id: 3 },
            { authorName: "知识实体管理", path: "/manage/instance", id: 4 },
            
            // { authorName: "知识动态管理", path: null, id:8 ,
            // children:[
            // { authorName: "知识抽取与更新", path: "/mergeGraph/extract", id: 10},

            // ]}
          ],
          id: 6,
        },
        {
          authorName: "知识抽取",
          path: null,
          children: [
            { authorName: "知识抽取管理", path: "/mergeGraph/extractManage", id: 3 },
            { authorName: "知识抽取", path: "/mergeGraph/extract", id: 4 },
          ]
        }
      ],

      iconObj: {
        // 0: "el-icon-s-home",
        1: "el-icon-s-check",
        2: "el-icon-upload",
        3: "el-icon-umbrella",
        4: "el-icon-s-management",
        5: "el-icon-collection",
        6: "el-icon-s-opportunity",
        7: "el-icon-s-promotion",
        8: "el-icon-menu",
        9: "el-icon-star-on",
        10: "el-icon-eleme",
      },
    };
  },
  watch: {
    $route(to, from) {
      console.log(to, from);
      // 监听路由变化，根据路由动态设置activeIndex
      if (
        to.path === "/manage/showTimeRel" ||
        to.path === "/manage/showGraph"
      ) {
        this.activeMenu = "/manage/depth"; // 例如，在特定路径下激活“关于”菜单
      }
      if (to.path === "/kgBase/cardLis") {
        this.activeMenu = "/kgBase/index"; // 例如，在特定路径下激活“关于”菜单
      }
      if (to.path === "/mergeGraph/merge") {
        this.activeMenu = "/mergeGraph/merge"; // 例如，在特定路径下激活“关于”菜单
      }
    },
  },
  created() {
    this.activeMenu = this.$route.path; // 初始化时设置activeIndex为当前路由
  },
  methods: {
    handleSelect(index) {
      this.activeMenu = index; // 记录选中的菜单路径
    },
  },
  // vuex进行管理isCollapse是否折叠组件定义
  computed: {
    ...mapGetters(["isCollapse"]),
    // 配置路由动态生成菜单选项
    routes() {
      // console.log(this.$router);
      const routes = this.$router.options.routes[1].children;
      // return this.$router;
      console.log(routes);
      return routes;
    },
  },
};
</script>

<style lang="less">
.el-menu {
  // background-color: rgba(0, 35, 61, 0.75) !important;
  background-color: rgba(0, 35, 61) !important;
  border: 0 !important;
}

/* 一级菜单悬浮样式 */
.el-menu-item:hover {
  background-color: rgba(24, 144, 255, 0.15) !important;
  /* 悬浮时背景色 */
  color: white !important;
  /* 悬浮时文字颜色 */
}

/* 有二级菜单的一级菜单悬浮样式 */
.el-submenu:hover>.el-submenu__title {
  background-color: rgba(24, 144, 255, 0.15) !important;
  /* 悬浮时背景色 */
  color: white !important;
  /* 悬浮时文字颜色 */
}

// .el-submenu.is-active:hover > .el-submenu__title {
//   background-color: rgba(24, 144, 255, 0.15) !important; /* 选中时的背景色 */
//   color: white !important; /* 选中时的文字颜色 */
// }

.el-submenu .el-menu-item {
  background-color: rgba(0, 35, 61, 0.75);
  color: rgba(255, 255, 255, 0.75);
}

/* 一级菜单样式 */
.el-menu-item {
  font-size: 18px !important;
  // font-weight: bold;
  transition: all 0.3s;
  padding: 0% !important;
  background-color: transparent;
  color: rgba(255, 255, 255, 0.75) !important;
}

.el-menu-item-group__title {
  padding: 0% !important;
}

/* 一级菜单选中时添加内边距 */
// .custom-menu .el-menu-item.is-active:not(.el-submenu__title) {
//   padding-left: 18px;
//   position: relative;
// }

.custom-menu .el-menu-item.is-active:not(.el-submenu__title)::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 3px;
  background-color: rgba(31, 187, 255, 1);
}

/* 仅二级菜单对应的一级菜单标题加样式 */
// .custom-menu .el-submenu.is-active>.el-submenu__title {
//   padding-left: 18px;
//   position: relative;
// }

.custom-menu .el-menu-item.is-active>.el-submenu__title::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 3px;
  background-color: rgba(31, 187, 255, 1);
}

.el-menu--collapse {
  width: 44px !important;
}

/* 一级菜单选中样式 */
.el-menu-item.is-active {
  background-color: rgba(1, 176, 255, 0.3) !important;
  /* 选中时背景色 */
  color: #ffffff !important;
  /* 选中时文字颜色 */
  font-weight: bold !important;
}

/* 一级菜单选中时的悬浮样式 */
// .el-menu-item.is-active:hover {
//   background-color: rgba(24, 144, 255, 0.15) !important;
//   /* 悬浮时的背景色微调 */
// }

/* 子菜单项悬浮与选中样式 */
.el-menu--collapse .el-menu-item:hover {
  background-color: rgba(24, 144, 255, 0.15);
  color: white;
}

.el-submenu__title {
  padding: 0% !important;
  font-size: 18px !important;
}

/* 修改二级菜单项样式 */
.el-menu-item-group .el-menu-item {
  font-size: 18px !important;
  /* 字体大小 */
  padding: 0 60px !important;
  /* 内边距调整 */
  background-color: rgba(12, 60, 97, 0.3);
  /* 背景色 */
  transition: background-color 0.3s;
  height: 46px !important;
}

/* 二级菜单选中样式 */
.el-menu-item-group .el-menu-item.is-active {
  background-color: rgba(24, 144, 255, 0.3) !important;
  /* 选中时背景色 */
  color: white !important;
  /* 选中时文字颜色 */
  font-weight: bold;
  /* 选中时文字加粗 */
  // border-radius: 4px;                  /* 可选：圆角 */
}

/* 二级菜单悬浮样式 */
.el-menu-item-group .el-menu-item:hover {
  background-color: rgba(24, 144, 255, 0.15) !important;
  /* 悬浮时背景色 */
  color: #ffffff !important;
  /* 悬浮时文字颜色 */
  // border-radius: 4px;                                  /* 可选：圆角 */
}

.el-menu-item,
.el-submenu__title {
  display: flex;
  align-items: center;
  min-height: 46px;
  /* 保持高度一致 */
  padding: 0 12px;
  /* 确保内边距一致 */
}

.el-menu-item img {
  flex-shrink: 0;
  /* 防止图标缩放 */
  // margin-right: 12px; /* 保证间距固定 */
}

/* 一级菜单选中时变色 */
// .el-submenu.is-active>.el-submenu__title {
//   background-color: rgba(1, 176, 255, 0.3) !important;
//   color: white !important;
//   font-weight: bold;
// }
/* 让一级菜单在收起状态下高亮 */
.el-menu--collapse .el-submenu.is-active {
  background-color: rgba(1, 176, 255, 0.3) !important;
  color: #ffffff !important;
  font-weight: bold !important;
  // position: relative;  /* 关键：确保::before能正确定位 */
  // overflow: hidden; /* 防止伪元素超出边界 */
}

/* 收起状态下，一级菜单的选中标识 */
.el-menu--collapse .el-submenu.is-active::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 3px;
  background-color: rgba(31, 187, 255, 1);
}
</style>
